module.exports = __webpack_public_path__ + "img/ジープ.0a0f2cbb.png";